<template>
  <div class="form-group has-float-label">
    <label for="phoneNo" class="phoneLabel"
      >Phone Number <span v-if="required" class="isRequired">*</span></label
    >
    <vue-tel-input
      @input="updatePhoneNumber"
      :v-model="internalPhoneNumber"
      id="phoneNo"
      @validate="isValidate"
      :preferredCountries="['NG', 'IN']"
      autoFormat="false"
      :validCharactersOnly="true"
      :inputOptions.showDialCode="false"
      :inputOptions.required="required"
      :dropdownOptions.showDialCodeInSelection="true"
      :dropdownOptions.showSearchBox="true"
    ></vue-tel-input>
  </div>
</template>
<script>
/* https://github.com/EducationLink/vue-tel-input more ref here*/
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";

export default {
  name: "input",
  components: {
    VueTelInput,
  },
  props: {
    phoneNumber: {
      type: Number,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalPhoneNumber: this.phoneNumber, // Syncing the prop with a local data property
    };
  },
  watch: {
    phoneNumber(val) {
      this.internalPhoneNumber = val; // Watch for prop changes and update internal data
    },
  },
  methods: {
    updatePhoneNumber(value) {
      this.internalPhoneNumber = value;
      this.$emit("input", value); // Emit the value back to the parent
    },
    isValidate(result) {
      this.$emit("validate", result);
    },
  },
};
</script>
<style scoped>
.vue-tel-input[data-v-29985a25] {
  border: 2px solid #007bff;
  height: 43px;
  border-radius: 0px;
  border-left-width: 4px;
}
.vue-tel-input[data-v-9d46625e] {
  border-radius: 5px;
  padding: 3px;
}
.phoneLabel {
  color: #777777;
}
.isRequired {
  color: red;
}
::v-deep .dropdown ul {
  z-index: 99;
}
.vue-tel-input:focus-within {
  box-shadow: none;
  border: 1px solid #7367f0;
}
</style>
